import { Country } from '../../../integrated-client/models/Country'

export interface ICountryEditorData {
  countryData?: Country
  validation?: any
}
export class CountryEditorData implements ICountryEditorData {

  countryData?: Country
  validation?: any
}